<!--
 Copyright 2022 by domX Private Company

 All rights reserved,
 also regarding any disposal, exploitation, reproduction,
 editing, distribution, as well as in the event of
 applications for industrial property rights.

 This software contains proprietary and confidential
 information of domX Private Company.
 The disclosure of confidential information without
 express authorization is prohibited.

 This software may include Open Source Software.
 As far as Open Source Software is included,
 your rights for the respective Open Source Software
 components are governed by the applicable
 Open Source Software licenses.
-->

<template class="fill-height">    
  <v-card
      flat
      class="secondary fill-height pa-12"
      height="25%">
    <v-form
      v-if="currInstallation"
      ref="form"
      lazy-validation
    >
      <v-list class="secondary" max-width="1000px">
        <v-subheader class="display-1 grayBold--text">
          {{$t("exportDataTitle")}}
        </v-subheader>
        <v-list-item>
          <v-list-item-content class="grayBold--text">
            <v-list-item-title class="subtitle-2 grayBold--text">

            </v-list-item-title>
            <v-flex xs12 sm12 md12 v-if="!payload.installation">
                <v-menu
                  ref="dateRangeMenuState"
                  v-model="dateRangeMenuState"
                  :close-on-content-click="false"
                  
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      class="mt-0 pt-0"
                      v-model="dateRangeText"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      light
                      v-bind="attrs"
                      v-on="on"
                      :rules="dateRangeRule"
                      :label="$t('dates_range')"
                    ></v-text-field>
                  </template>
                    <v-date-picker
                      v-model="dateRange"
                      no-title
                      range
                      scrollable
                      width="690px"
                      @change="dateRangeUpdated"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="dateRangeMenuState = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.dateRangeMenuState.save(dateRange)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 s6 md6>
                <v-text-field disabled light v-model="currDeviceId" append-icon="mdi-cellphone-cog" class="mr-5" :label="$t('device_id')" />
              </v-flex>
              <v-flex xs12 s6 md6>
                <v-autocomplete
                  v-model="exportModel.metric"
                  :items="deviceMetricList"
                  :label="$t('metrics')"
                  multiple
                  light
                  item-text="text"
                  item-value="value"
                  persistent-hint
                  clearable
                  :loading="isLoadingMetrics"
                  :rules="metricsRule"
                >
                <template v-slot:selection="data">
                  <div v-if="exportModel.metric.length < 3">
                    {{ data.index > 0 ? ',' : '' }}  
                    {{ `${data.item['text'].trim()}` }}
                    <!-- <span v-if="selectedFilters.length > 1">&nbsp;</span> -->
                  </div>
                  <v-chip small v-else-if="data.index === 0">
                    {{ `${exportModel.metric.length} ${$t('itemsSelected')}` }}
                  </v-chip>
                </template>
              </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-autocomplete
                  light
                  class="grayBold--text mr-5"
                  v-model="exportModel.interval"
                  :items="intervalCombo"
                  item-text="text"
                  item-value="period"
                  :label="$t('interval')"
                  clearable
                  required
                  :rules="intervalRule"
                >
                <template v-slot:no-data>
                  <div class="px-4">{{ $t('comboNoData') }}</div>
                </template>
                </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-autocomplete
                  light
                  class="grayBold--text"
                  v-model="exportModel.file_type"
                  :items="exportType"
                  item-text="file_type"
                  item-value="file_type"
                  :label="$t('export_type')"
                  clearable
                  required
                  :rules="exportFileTypeRule"
                >
                <template v-slot:no-data>
                  <div class="px-4">{{ $t('comboNoData') }}</div>
                </template>
                </v-autocomplete>
              </v-flex>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          depressed
          right
          light
          color="grayBold--text secondary"
          @click="hideModal()"
        >
          {{$t("cancel")}} 
        </v-btn>
        <v-btn
          color="primary"
          depressed
          right
          large
          class="modal-update"
          @click="doDeviceExport"><v-icon left>mdi-pencil</v-icon>{{$t("export")}}</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { commonModule, installationsModule, devicesModule, companyModule } from '@/store/modules/store-accessor'
import dayjs from 'dayjs';

@Component
export default class ExportDeviceDataModal extends Vue {
  @Prop() payload!: any;

  loadingMetrics = true;
  dateRangeMenuState = false;

  dateRange = [dayjs().startOf('day').format('YYYY-MM-DD'), dayjs().endOf('day').format('YYYY-MM-DD')];
  deviceMetrics: Record<string, unknown> = {};

  get currInstallation () {
    return installationsModule.currentInstallation;
  }

  get currDeviceId () {
    return devicesModule.currentDevice.data.deviceId;
  }

  get allInstallations() {
    return commonModule.installationsCombo;
  }

  get isLoadingMetrics () {
    return this.loadingMetrics;
  }
  get installationDescriptionIsEnabled() {
    return (companyModule.company?.preferences as any)?.installation_description;
  }

  get deviceMetricList() {
    const translated : string[]= this.deviceMetrics.historical as string[];//(this.deviceMetrics.historical as string[]).map((item) => this.$i18n.t(item))
    return (translated?.map((item) => { return {value: item,  text: this.$i18n.t(item)} }))
  }

  dateRangeUpdated(date: any) {
    let sorted = date.sort((a: any, b: any) => {
      var dateA = dayjs(a).unix(),
          dateB = dayjs(b).unix();
      if (dateB > dateA) {
        return -1;
      } else {
        return 1;
      }
    })
    let dateFrom = dayjs(sorted[0]).startOf('day').toISOString();
    let dateTo = dayjs(sorted[1]).endOf('day').toISOString();
    
    this.exportModel.time_from = dateFrom;
    this.exportModel.time_to = dateTo;
  }

  get dateRangeText () {
    // let dateRangeText = this.dateRange.map((item) => dayjs(item).format('YYYY-MM-DD HH:mm'))
    let sorted: any = this.dateRange.sort((a: any, b: any) => {
      var dateA = dayjs(a).unix(),
          dateB = dayjs(b).unix();
      if (dateB > dateA) {
        return -1;
      } else {
        return 1;
      }
    })


    return sorted.join(' - ')
  }
 
  exportModel = {
    time_from: dayjs().startOf('day').toISOString(),
    time_to: dayjs().endOf('day').toISOString(),
    interval: this.intervalCombo[0].period,
    metric: [],
    file_type: this.exportType[0].file_type
  }

  google_address:any;

  evt:any;

  dateRangeRule = [
    (val: any) => {
      if ((val.split(' - '))[1] !== undefined) {
        const date1 = dayjs((val.split(' - '))[1])

        let dateDiff = date1.diff((val.split(' - '))[0], 'day', true) //
        let dateLimit = this.exportModel.interval.includes('d') ? 365 : 31 

        return (dateDiff <= dateLimit) || this.$i18n.t("date_range_error", {'days': dateLimit})
      }
      return true;
    },
    (val: any) => ((val.split(' - '))[1] !== undefined) || this.$i18n.t("date_range_required"),
  ]

  metricsRule = [
    (val: any) => val?.length > 0 || this.$i18n.t("metrics_required"),
  ]

  intervalRule = [
    (val: any) => !!val || this.$i18n.t("interval_required"),
  ]

  exportFileTypeRule = [
    (val: any) => !!val || this.$i18n.t("export_type_required"),
  ]



  //Add Validation for two 



  installationText(item: any) {
    let installation_arr = item.is_business 
    ?
    [item.tag_id.split('_').pop(), `${item.address ? item.address : item.area }`, (item.description && this.installationDescriptionIsEnabled) ? item.description : '', `${item.entity_name} (${item.client_name})`, item.phone]
    :
    [item.tag_id.split('_').pop(), `${item.address ? item.address : item.area }`,(item.description && this.installationDescriptionIsEnabled) ? item.description : '', item.client_name, item.phone]

    return installation_arr.filter(Boolean).join(' | ')
  }

  async hideModal () {
    commonModule.hideModal();
  }

  async doDeviceExport () {
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      await devicesModule.exportDeviceData({ deviceId: this.currDeviceId, exportModel: this.exportModel});
      this.hideModal();  
    }
  }

  get intervalCombo() {
      const intervalCombo: any = [
        { "period" : '1m' , "text" : `1 ${this.$i18n.t("minute")}` },
        { "period" : '30m' , "text" : `30 ${this.$i18n.t("minutes")}` },
        { "period" : '1h' , "text" : `1 ${this.$i18n.t("hour")}`  },
        { "period" : '1d' , "text" : `1 ${this.$i18n.t("day")}` },
        { "period" : '7d' , "text" : `7 ${this.$i18n.t("days")}` },
        { "period" : '30d' , "text" : `30 ${this.$i18n.t("days")}` },
      ];
      return intervalCombo
  }

  get exportType() {
      const fileTypeCombo: any = [
        // { "file_type" : 'CSV' },
        { "file_type" : 'JSON' },
      ];
      return fileTypeCombo
  }

  async mounted() {
    commonModule.initSnackbar({});
    this.loadingMetrics = true;
    this.deviceMetrics = await devicesModule.getDeviceMetrics(this.currDeviceId);
    this.loadingMetrics = false;  
  }

  isNumber(evt:any) {
      evt = evt || window.event;
      let charCode = evt.which || evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
      return false;
  }
};
</script>

